// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2-3_R","label":"LabeledBox_label__2bWlf"};